import {getCookie} from "../Cookies";

let apiKey = getCookie('akey');
if(!apiKey && window.location.href.search('auth.html') == -1){
    window.location.href = '/auth.html';
}
export let todoistConfig = {
    apiKey: apiKey

};
